import { render, staticRenderFns } from "./CopyAdServingCodeDialog.vue?vue&type=template&id=4b5aa4b2&"
import script from "./CopyAdServingCodeDialog.vue?vue&type=script&lang=js&"
export * from "./CopyAdServingCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports